import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=4db11156&scoped=true"
import script from "./page-not-found.vue?vue&type=script&lang=js"
export * from "./page-not-found.vue?vue&type=script&lang=js"
import style0 from "./page-not-found.vue?vue&type=style&index=0&id=4db11156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db11156",
  null
  
)

export default component.exports